import { Box, Stack } from "@chakra-ui/react";
import type { EventRevisionDto } from "../../../../autogen/bff-api";
import { ChangeLogEntry } from "./ChangeLogEntry";

interface Props {
  revisions: EventRevisionDto[];
}

export const ChangeLogList = ({ revisions }: Props) => {
  const newestFirst = [...revisions].sort((a, b) =>
    (b.publishedAt ?? b.createdAt).localeCompare(a.publishedAt ?? a.createdAt),
  );

  return (
    <Stack spacing="3">
      {newestFirst.map((revision) => (
        <Box key={revision.id} borderWidth="1px" borderColor="smBorder" borderRadius="md" p="4">
          <ChangeLogEntry revision={revision} />
        </Box>
      ))}
    </Stack>
  );
};
